import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Select, Option} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Select, {
            'multiple': true,
            'draggable': true,
            'children': [
                _$cc(Option, {
                    'value': 'Monday',
                    'children': '星期一'
                }),
                _$cc(Option, {
                    'value': 'Tuesday',
                    'children': '星期二'
                }),
                _$cc(Option, {
                    'value': 'Wednesday',
                    'children': '星期三'
                }),
                _$cc(Option, {
                    'value': 'Thursday',
                    'children': '星期四'
                }),
                _$cc(Option, {
                    'value': 'Friday',
                    'children': '星期五'
                }),
                _$cc(Option, {
                    'value': 'Saturday',
                    'children': '星期六'
                }),
                _$cc(Option, {
                    'value': 'Sunday',
                    'children': '星期天'
                })
            ],
            'ev-$model:value': function($v) {
                $this.set('days1', $v);
            },
            'value': $this.get('days1')
        }),
        JSON.stringify(this.get('days1')),
        _$ce(2, 'br'),
        _$ce(2, 'br'),
        _$cc(Select, {
            'multiple': true,
            'draggable': true,
            'nowrap': true,
            'children': [
                _$cc(Option, {
                    'value': 'Monday',
                    'children': '星期一'
                }),
                _$cc(Option, {
                    'value': 'Tuesday',
                    'children': '星期二'
                }),
                _$cc(Option, {
                    'value': 'Wednesday',
                    'children': '星期三'
                }),
                _$cc(Option, {
                    'value': 'Thursday',
                    'children': '星期四'
                }),
                _$cc(Option, {
                    'value': 'Friday',
                    'children': '星期五'
                }),
                _$cc(Option, {
                    'value': 'Saturday',
                    'children': '星期六'
                }),
                _$cc(Option, {
                    'value': 'Sunday',
                    'children': '星期天'
                })
            ],
            'ev-$model:value': function($v) {
                $this.set('days2', $v);
            },
            'value': $this.get('days2')
        }),
        JSON.stringify(this.get('days2'))
    ], 0 /* UnknownChildren */);
};